import { AxiosInstance } from "axios"

import {
    CreateTermsAndConditions,
    TermsAndConditions,
    TermsAndConditionsItem,
    UpdateTermsAndConditions,
} from "./termsAndConditionTypes"
import { ServiceResponse } from "../../../../../core/api/apiTypes"

export enum TermsAndConditionQuery {
    LIST = "terms-and-conditions-for-supplier",
    DETAILS = "details-terms-and-conditions",
}

export type FetchSupplierTermsAndConditionsResponse = Readonly<{
    termsAndConditions: TermsAndConditionsItem[]
}>

export type FetchTermsAndConditionsResponse = Readonly<{
    termsAndConditionsDetails: TermsAndConditions
}>

type FetchSupplierTermsAndConditionsParams = Readonly<{
    supplierId: number
}>

type FetchTermsAndConditionsParams = Readonly<{
    termsAndConditionsId: number
}>

export async function fetchTermsAndConditions(
    { supplierId }: FetchSupplierTermsAndConditionsParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<FetchSupplierTermsAndConditionsResponse> {
    const url = `/suppliers/${supplierId}/termsAndConditions`

    const response = await axios.get(url, { signal })

    return response.data
}

export async function fetchTermsAndConditionsById(
    { termsAndConditionsId }: FetchTermsAndConditionsParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<FetchTermsAndConditionsResponse> {
    const url = `/termsAndConditions/${termsAndConditionsId}`

    const response = await axios.get(url, { signal })

    return response.data
}

export async function createTermsAndCondition(
    termsAndConditions: CreateTermsAndConditions,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ServiceResponse<{}>> {
    const url = "/termsAndConditions"

    const response = await axios.post(
        url,
        {
            termsAndConditions,
        },
        {
            signal,
        },
    )

    return response.data
}

export async function editTermsAndCondition(
    {
        termsAndConditionsId,
        termsAndConditions,
    }: { termsAndConditionsId: string; termsAndConditions: UpdateTermsAndConditions },
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ServiceResponse<{}>> {
    const url = `/termsAndConditions/${termsAndConditionsId}`

    const response = await axios.post(
        url,
        {
            termsAndConditions,
        },
        {
            signal,
        },
    )

    return response.data
}

type DeleteTermsAndConditions = Readonly<{
    termsAndConditionsId: number
}>

export async function deleteTermsAndConditions(
    { termsAndConditionsId }: DeleteTermsAndConditions,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ServiceResponse<{}>> {
    const url = `/termsAndConditions/${termsAndConditionsId}`

    const response = await axios.delete(url, {
        signal,
    })

    return response.data
}
